import { render, staticRenderFns } from "./RegistryPayButton.vue?vue&type=template&id=34aa5e4f&"
import script from "./RegistryPayButton.vue?vue&type=script&lang=js&"
export * from "./RegistryPayButton.vue?vue&type=script&lang=js&"
import style0 from "./RegistryPayButton.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports